import PropTypes from "prop-types";
import EnergyBankerTimeLog from "./energy-banker-time-log/energy-banker-time-log";

const DashboardEnergyBanker = (props) => {
  return (
    <div>
      {(props.energyBankerTimeLogItems) &&
        <EnergyBankerTimeLog items={props.energyBankerTimeLogItems} isSI={props.isSI}/>
      }
    </div>
  );
};

DashboardEnergyBanker.propTypes = {
  energyBankerTimeLogItems: PropTypes.shape({
    User: PropTypes.shape({
      Id: PropTypes.number,
      Name: PropTypes.string,
    }),
    TotalHoursLastWeek: PropTypes.number,
    TotalWeekendHoursLastWeek: PropTypes.number,
    TotalHoursNextWeek: PropTypes.number,
    Projects: PropTypes.arrayOf(
      PropTypes.shape({
        GroupName: PropTypes.string.isRequired,
        Deals: PropTypes.arrayOf(
          PropTypes.shape({
            ProjectId: PropTypes.number.isRequired,
            ProjectIdString: PropTypes.string.isRequired,
            TaskId: PropTypes.number.isRequired,
            ProjectName: PropTypes.string.isRequired,
            IsOverdue: PropTypes.bool,
            Company: PropTypes.string,
            LastWeekHours: PropTypes.number,
            WeekendHours: PropTypes.number,
            ActualTotalHours: PropTypes.number,
            NextWeekHours: PropTypes.number,
            Members: PropTypes.arrayOf(
              PropTypes.shape({
                User: PropTypes.shape({
                  Id: PropTypes.number.isRequired,
                  Name: PropTypes.string.isRequired,
                }),
                IsOwner: PropTypes.bool.isRequired,
              })
            ),
          })
        ),
      })
    ),
  }),
  isSI: PropTypes.bool,
};

export default DashboardEnergyBanker;